import React from 'react';
import { View } from 'react-native';

export function HomeCohortCardSkeleton() {
  return (
    <View
 className="animate-pulse rounded-2xl border border-zinc-200/80 bg-zinc-100 dark:bg-zinc-900 p-3 dark:border-zinc-800 dark:bg-zinc-900/90"
      style={{ width: 208, marginRight: 12 }}>
 <View className="mb-2 h-4 w-3/4 rounded-lg bg-zinc-200 dark:bg-zinc-700/90 dark:bg-zinc-700" />
 <View className="mb-2 h-3 w-1/2 rounded-lg bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700/80" />
 <View className="mt-3 h-9 w-full rounded-xl bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
    </View>
  );
}

export function HomeScreenSkeleton() {
  return (
 <View className="flex-1 bg-white dark:bg-black px-5 pt-4 dark:bg-black">
 <View className="mb-5 flex-row justify-between gap-3">
 <View className="min-w-0 flex-1">
 <View className="mb-2 h-8 w-4/5 animate-pulse rounded-lg bg-zinc-200 dark:bg-zinc-700/90 dark:bg-zinc-800" />
 <View className="h-4 w-full animate-pulse rounded-lg bg-zinc-100 dark:bg-zinc-900 dark:bg-zinc-900" />
 <View className="mt-2 h-4 w-11/12 animate-pulse rounded-lg bg-zinc-100 dark:bg-zinc-900 dark:bg-zinc-900" />
        </View>
 <View className="h-12 w-24 animate-pulse rounded-2xl bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-800" />
      </View>
 <View className="mb-2 h-3 w-48 animate-pulse rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-800" />
 <View className="mb-6 flex-row">
        <HomeCohortCardSkeleton />
        <HomeCohortCardSkeleton />
      </View>
 <View className="mb-3 h-3 w-40 animate-pulse rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-800" />
 <View className="mb-2 h-20 animate-pulse rounded-2xl bg-zinc-100 dark:bg-zinc-900 dark:bg-zinc-900" />
 <View className="mb-2 h-20 animate-pulse rounded-2xl bg-zinc-100 dark:bg-zinc-900 dark:bg-zinc-900" />
    </View>
  );
}

export function MarketplaceGridSkeleton({ cardWidth }: { cardWidth: number }) {
  return (
 <View className="flex-1 flex-row flex-wrap gap-x-3 bg-white dark:bg-black px-5 pt-4 dark:bg-black">
      {[0, 1, 2, 3].map(i => (
 <View key={i} style={{ width: cardWidth }} className="mb-3">
 <View className="animate-pulse overflow-hidden rounded-2xl border border-zinc-200 bg-zinc-100 dark:bg-zinc-900 dark:border-zinc-800 dark:bg-zinc-900">
 <View className="h-[150px] w-full bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-800" />
 <View className="p-3">
 <View className="mb-2 h-3 w-1/3 rounded bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
 <View className="mb-2 h-4 w-full rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="mb-3 h-5 w-1/2 rounded bg-zinc-200 dark:bg-zinc-800/70 dark:bg-orange-900/40" />
 <View className="h-9 w-full rounded-xl bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
            </View>
          </View>
        </View>
      ))}
    </View>
  );
}

export function ForumPostSkeleton() {
  return (
 <View className="mb-3 animate-pulse rounded-2xl border border-zinc-200 bg-zinc-100 dark:bg-zinc-900 p-4 dark:border-zinc-800 dark:bg-zinc-900/95">
 <View className="mb-3 flex-row justify-between">
 <View className="h-6 w-20 rounded-full bg-zinc-200 dark:bg-zinc-800/80 dark:bg-orange-900/50" />
 <View className="h-3 w-16 rounded bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
      </View>
 <View className="mb-2 h-5 w-11/12 rounded bg-zinc-200 dark:bg-zinc-700/90 dark:bg-zinc-700" />
 <View className="mb-1 h-4 w-full rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="mb-4 h-4 w-4/5 rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="flex-row items-center border-t border-zinc-300/50 pt-3 dark:border-zinc-800">
 <View className="mr-3 h-10 w-10 rounded-full bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
 <View className="h-4 flex-1 rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
      </View>
    </View>
  );
}

export function ForumListSkeleton() {
  return (
 <View className="flex-1 bg-white dark:bg-black px-4 pt-2 dark:bg-black">
      <ForumPostSkeleton />
      <ForumPostSkeleton />
      <ForumPostSkeleton />
    </View>
  );
}

export function EventsListSkeleton() {
  return (
 <View className="flex-1 bg-white dark:bg-black px-5 pt-4 dark:bg-black">
      {[0, 1, 2].map(i => (
        <View
          key={i}
 className="mb-4 animate-pulse rounded-2xl border border-zinc-200 bg-zinc-100 dark:bg-zinc-900 p-4 dark:border-zinc-800 dark:bg-zinc-900">
 <View className="mb-2 h-6 w-3/4 rounded-lg bg-zinc-200 dark:bg-zinc-700/90 dark:bg-zinc-700" />
 <View className="mb-2 h-4 w-full rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="h-4 w-1/2 rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="mt-4 h-10 w-24 self-end rounded-xl bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
        </View>
      ))}
    </View>
  );
}

export function ForumPostDetailSkeleton() {
  return (
 <View className="flex-1 bg-white dark:bg-black px-4 py-3 dark:bg-black">
 <View className="mb-4 flex-row justify-between">
 <View className="h-6 w-24 rounded-full bg-zinc-200 dark:bg-zinc-800/80 dark:bg-orange-900/50" />
 <View className="h-3 w-20 rounded bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
      </View>
 <View className="mb-3 h-8 w-full rounded bg-zinc-200 dark:bg-zinc-700/90 dark:bg-zinc-700" />
 <View className="mb-2 h-4 w-full rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="mb-2 h-4 w-full rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="mb-6 h-4 w-3/4 rounded bg-zinc-200 dark:bg-zinc-700/70 dark:bg-zinc-700" />
 <View className="h-12 w-40 rounded-2xl bg-zinc-200 dark:bg-zinc-700/80 dark:bg-zinc-700" />
    </View>
  );
}
